import React, { useState } from 'react';

import dynamic from 'next/dynamic'

import { THEME } from '@constants/index';
import { Button, openDrawer, openModal } from '@element/index'
import { useIsomorphicLayoutEffect } from '@lib/hooks';
import { I18n } from '@utils/index';
import { ModalTitle } from '@widget/user/FundsPassword/ModalTitle';

import styles from './index.module.less';

const CodeInput = dynamic(() => import('@components/index').then(modal => modal.CodeInput), { ssr: false });

export interface MainProps {
  close: () => void;
  resolve: (value: string) => void;
  /** 点击重新发送 */
  onSend?: () => Promise<boolean>;
  /** 输入完成 */
  onComplete: (value: string) => Promise<{ errorText?: string; status?: 'DONE' }>;
  theme?: Theme;
}

const Main: React.FC<MainProps> = (props) => {
  const { onSend, onComplete, close, resolve, theme = THEME.HIGHLIGHT } = props;
  const [loading, setLoading] = useState<boolean>(false)
  const [errorText, setErrorText] = useState<string>()
  const [count, setCount] = useState(60)
  const onFulfill = async (value: string) => {
    setLoading(true)
    const res = await onComplete(value);
    setLoading(false);
    if (res.errorText) {
      setErrorText(res.errorText);
    }
    if (res.status === 'DONE') {
      resolve(value);
      close()
    }
  }
  const onChange = () => {
    setErrorText('');
  }
  const onClick = async () => {
    const res = await onSend();
    if (res) updateCountDown(60);
  }
  const updateCountDown = (count) => {
    if (count <= 0) {
      return;
    }
    setTimeout(() => {
      const newCount = count - 1
      setCount(newCount)
      updateCountDown(newCount);
    }, 1000)
  }

  useIsomorphicLayoutEffect(() => {
    updateCountDown(60)
  }, [])
  return (
    <div className={styles.container}>

      <CodeInput
        type="number"
        theme={theme}
        status={errorText ? 'error' : undefined}
        className={styles.codeInput}
        onComplete={onFulfill}
        onChange={onChange}
      />
      {!!errorText && <p className={styles.error}>{errorText}</p>}
      <div className={styles.footer}>
        <Button type="primary" loading={loading} disabled={!!count} onClick={onClick} className={styles.btn} borderRadius={8}>{I18n.t('register_resend')}{!!count && `(${count}s)` }</Button>
      </div>
    </div>
  );
}

interface IParams extends Omit<MainProps, 'resolve' | 'close'> {
  title: string;
  subTitle: string;
  /** 抽屉或弹窗形式 */
  mode?: 'modal'|'drawer';
}

export const openVerifyCode = (params: IParams): Promise<any> => {
  const { title, subTitle, mode } = params;
  return new Promise((resolve) => {
    if (mode === 'drawer') {
      openDrawer({
        content: (props) => (
          <div className={styles.drawer}>
            <ModalTitle theme={params.theme} title={title} subTitle={subTitle} className={styles.modalTitle} />
            <Main close={props.close} resolve={props.resolve} {...params} />
          </div>
        ),
        onClose: (close) => {
          return close;
        },
        theme: params.theme
      }).then(res => {
        resolve(res);
      })
    } else {
      openModal({
        title: <ModalTitle title={title} subTitle={subTitle} />,
        theme: params.theme,
        onClose: (close) => async () => {
          close()
          resolve('cancel');
        },
        children: (close) => (
          <Main close={close} resolve={resolve} {...params} />
        ),
        footer: null
      })
    }
  })
}
